module.exports = __webpack_public_path__ + "img/zhuangpeiti.asm.63fa0039.jpg";